<template>
    <div class="sekcija"
        v-if="podatki.find(i => i.statuspridelkanaziv == 'Ekološki') || podatki.find(i => (i.statuspridelkanaziv == 'Iz preusmeritve' || i.statuspridelkanaziv == '1. leto preusmeritve'))">

        <div class="kategorije">
            <!--<div class="naslov">Proizvodi in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 (2) za proizvode s področja uporabe Uredbe (EU) 2018/848</div>-->
            <div class="naslov-kategorije">
                {{ naslov }}
            </div>
            <div style="display: flex; flex-direction: row;gap:0.33em">
                <div class="naslov">
                    {{ __("Metoda pridelave: ") }}
                </div>
                <div
                    v-if="podatki.find(i => i.statuspridelkanaziv == 'Neekološki') && podatki.find(i => i.statuspridelkanaziv == 'Ekološki')">
                    <div>
                        {{ __("Ekološka pridelava z neekološko pridelavo") }}
                    </div>
                    <!--  <div class="proizvodi">
                <div class="proizvodi-row" v-for="proizvod in podatki.konvencionalno.map(i=>i.naziv)">
                    <div class="proizvodi-ime">{{proizvod}}</div>  
                    <div class="proizvodi-status">Konvencionalno</div>  
                </div>  
            </div>  
        -->
                </div>
                <div v-else-if="podatki.find(i => i.statuspridelkanaziv == 'Ekološki')">
                    <div>
                        <span v-if="!proizvod">{{ __("Ekološka pridelava, razen v obdobju preusmeritve") }}</span>
                        <span v-if="proizvod">{{ __("Pridelava ekoloških proizvodov") }}</span>
                    </div>
                    <!--<div class="proizvodi">
                <div class="proizvodi-row" v-for="proizvod in podatki.eko.map(i=>i.naziv)">
                    <div class="proizvodi-ime">{{proizvod}}</div>  
                    <div class="proizvodi-status">Ekološki</div>  
                </div>  
            </div>-->
                </div>

                <div
                    v-if="podatki.find(i => (i.statuspridelkanaziv == 'Iz preusmeritve' || i.statuspridelkanaziv == '1. leto preusmeritve'))">
                    <div>
                        <span v-if="!proizvod">{{ __("Pridelava v obdobju preusmeritve") }}</span>
                        <span v-if="proizvod">{{ __("Pridelava proizvodov iz preusmeritve") }}</span>
                    </div>
                    <!--<div class="proizvodi">
                <div class="proizvodi-row" v-for="proizvod in podatki.preusmeritev.map(i=>i.naziv)">
                    <div class="proizvodi-ime">{{proizvod}}</div>  
                    <div class="proizvodi-status">iz preusmeritve</div>  
                </div>  
            </div>
        -->
                </div>
            </div>

        </div>

    </div>
</template>
<script>
export default {
    props: ["naslov", "proizvod", "podatki"],

    created() {
        console.log(this.podatki)
    },
    methods: {
        __: function (value) {

            if (!this.$route.query.lang)
                return value


            let lang = this.$route.query.lang
            var translation = {};

            translation["de"] = {
                "Metoda pridelave: ": "Produktionsverfahren: ",
                "Ekološka pridelava z neekološko pridelavo": "Ökologische/biologische Produktion mit nichtökologischer/nichtbiologischer Produktion",
                "Ekološka pridelava, razen v obdobju preusmeritve": "Ökologische/biologische Produktion außer während des Umstellungszeitraums",
                "Pridelava ekoloških proizvodov": "Produktion ökologischer/biologischer Erzeugnisse",
                "Pridelava v obdobju preusmeritve": "Produktion während des Umstellungszeitraums",
                "Pridelava proizvodov iz preusmeritve": "Produktion von Umstellungserzeugnissen",
            };
            translation["en"] = {
                "Metoda pridelave: ": "Production method: ",
                "Ekološka pridelava z neekološko pridelavo": "Organic production with non-organic production",
                "Ekološka pridelava, razen v obdobju preusmeritve": "Organic production excluding during the conversion period",
                "Pridelava ekoloških proizvodov": "Production of organic products",
                "Pridelava v obdobju preusmeritve": "Production during the conversion period",
                "Pridelava proizvodov iz preusmeritve": "Production of in-conversion products",
            };

            if (!translation[lang])
                return value;

            return translation[lang][value] ? translation[lang][value] : value;


        }
    }

}
</script>
<style scoped>
.proizvodi-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.kategorije {
    margin-top: 1em;
    margin-bottom: 1em;
    border: 1px solid var(--accent);
    padding: 0.5em;
}

.naslov-kategorije {

    margin-bottom: 0.5em;
    font-weight: bold;

    color: var(--accent);
}

.proizvodi {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.proizvodi-ime,
.proizvodi-status {
    font-weight: bold;
}
</style>
